import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { DistributionList3, DistributionListDetails } from "app/views/campaign-3/models/campaign-3.model";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { BasketService } from "../basket.service";
import { Basket, CreateBasketPayload } from "../baskets.model";
import { MessageService } from "primeng/primeng";

@Component({
  selector: 'app-basket-creation',
  templateUrl: './basket-creation.component.html',
  styleUrls: ['./basket-creation.component.css']
})
export class BasketCreationComponent implements OnInit {

  breadcrumbs: Array<BreadCrumbModel> = [];
  distributionListDetail: DistributionList3;

  @ViewChild('basket_name') basketName;
  @ViewChild('basket_code') basketCode;
  @ViewChild('basket_description') basketDescription;

  basketToEdit: Basket;


  fieldModel = {
    name: '',
    description: '',
    code: ''
  }
  idBasketToEdit;
  readOnly: boolean = false;
  editMode: boolean = false;

  constructor(
    public router: Router,
    private translate: TranslateService,
    private basketService: BasketService,
    private srvNotify: MessageService,
    private translateService: TranslateService,
    private route: ActivatedRoute


  ) { }
  ngOnInit(): void {
    this.initBreadCrumbs();

    // Controlla se esiste idRow nella query params
    this.route.queryParams.subscribe(params => {
      const idRow = params['idBasket'];
      if (idRow) {
        this.editMode=true;
        this.idBasketToEdit=idRow;
        this.loadBasketDetail(+idRow); // + converte string in number
      }
    });
  }



    private initBreadCrumbs(): void {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.code = "bc1";
    breadcrumb.description = this.translateService.instant('breadCrumb.baskets_list');
    breadcrumb.routerLink = "/baskets-list";
    this.breadcrumbs.push(breadcrumb);

    const breadcrumb2 = new BreadCrumbModel();
    breadcrumb2.code = "bc2";
    breadcrumb2.description = this.translateService.instant('breadCrumb.basket_create_edit');
    breadcrumb2.routerLink = "/basket-creation";
    this.breadcrumbs.push(breadcrumb2);
  }



private loadBasketDetail(id: number): void {
  this.basketService.getBasket(id).subscribe(
    res => {
      this.basketToEdit = res.data;
      this.populateFormFields();
    },
    err => console.error('Errore caricamento basket', err)
  );
}

/**
 * Popola i campi del form con i dati del basket da modificare
 */
private populateFormFields(): void {
  if (!this.basketToEdit) return;

  this.fieldModel = {
    name: this.basketToEdit.name || '',
    code: this.basketToEdit.code || '',
    description: this.basketToEdit.description || ''
  };
}


  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }

  onBackAction(): void {
    this.router.navigate(['/baskets-list']);
  }

  onSaveChanges(): void {
    this.performBasketValidation();
  }


  private buildCreateBasketPayload(): CreateBasketPayload {
    return {
      name: this.fieldModel.name,
      description: this.fieldModel.description,
      code: this.fieldModel.code,
      productItems: []
    };
  }

  performBasketValidation(): void {
    const fields = [
      this.basketName,
      this.basketCode,
      this.basketDescription
    ];

    let allValid = true;

    fields.forEach(field => {
      field.performValidation();
      if (!field.valid) {
        allValid = false;
        console.error(`Errore nel campo: ${field.errorMessage}`);
      }
    });

    if (!allValid) {
      console.error('Errore nella validazione. Verifica i campi evidenziati.');
      return;
    }

    console.log('Tutti i campi sono validi. Salvataggio in corso...');

    const payload: CreateBasketPayload = this.buildCreateBasketPayload();

    if (this.editMode) {
      this.basketService
        .editBasket(payload, this.idBasketToEdit)
        .subscribe({
          next: res => {
            if (res) {
              this.srvNotify.add({
                severity: 'success',
                summary: this.translateService.instant('common.success'),
                detail: this.translateService.instant('baskets.update_success'),
                life: 4000
              });

              this.goToBasketList(res.id);
            }
          },
          error: err => {
            console.error('[editBasket] error:', err);

            this.srvNotify.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant('baskets.update_error'),
              life: 5000
            });
          }
        });
    } else {
      this.basketService
        .createNewBasket(payload)
        .subscribe({
          next: res => {
            if (res) {
              this.srvNotify.add({
                severity: 'success',
                summary: this.translateService.instant('common.success'),
                detail: this.translateService.instant('baskets.create_success'),
                life: 4000
              });

              this.goToBasketList(res.id);
            }
          },
          error: err => {
            console.error('[createNewBasket] error:', err);

            this.srvNotify.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant('baskets.create_error'),
              life: 5000
            });
          }
        });
    }

  }


  //TODO potrebbero chiedermi di tornare alla stessa che ho creato, devo salvarmi l'id dalla risposta e
  //lanciarlo qui per ritornare alla kontable e aggiungerla ai suoi parametri 
  goToBasketList(idBakset) {
  
        this.router.navigate(['/baskets-list'], {
        queryParams: { basketId: idBakset }
      });
  }



  
}



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-creation/basket-creation.component.ts